<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="bg-chsc-indigo-500">
        <UiContainer
            max-width="max-w-3xl"
        >
            <div class="grid grid-cols-12">
                <!-- <div class="col-span-5 flex justify-end">
                    <img
                        v-motion-slide-visible-once-right
                        :src="blok?.image.filename"
                        :alt="blok?.image.alt"
                        class="max-w-none"
                    >
                </div> -->
                <div class="col-span-12 py-20 flex flex-col justify-around">
                    <div class="[&>h3]:text-chsc-yellow [&>h3]:fs-4xl [&>h3]:font-medium [&>h3]:mb-8 [&>p]:text-white [&>p]:fs-xl">
                        <StoryblokRichText :doc="blok?.launch" />
                    </div>
                    <div class="mt-6 [&>h3]:text-chsc-yellow [&>h3]:fs-4xl [&>h3]:font-medium [&>h3]:mb-8 [&>p]:text-white [&>p]:fs-xl">
                        <StoryblokRichText :doc="blok?.contact" />
                    </div>
                </div>
            </div>
        </UiContainer>
    </section>
</template>
